<template>
<div>
    <section class="checkout-nav-section">
        <div class="checkoutnav_wrap">
            <div class="checkoutnav_div">
                <a href="#" class="link-block-73 w-inline-block"><img src="@/assets/images/NewSelf_Logo.png" loading="lazy" sizes="84.03125px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-800.png 800w, @/assets/images/NewSelf_Logo.png 1000w" alt="" class="image-487"></a>
                <div class="checkoutnav_progressdiv">
                    <div class="progress_step_div"></div>
                    <div class="progress_step_div current"></div>
                    <div class="progress_step_div"></div>
                    <div class="progress_step_div"></div>
                </div>
            </div>
        </div>
    </section>
        <section class="checkout-section" v-if="active_el==1">
            <div class="checkoutb_wrap">
                <div class="checkoutb_div">
                    <div class="upsell_wrap">
                        <div class="upsell-header-div">
                            <div class="text-block-1181">Improve Results.<br>Eliminate Side Effects.</div>
                            <p class="paragraph-15-14">Supercharge your results with prescription B12 injections and instant nausea relief for less than insurance.</p>
                        </div>
                        <div class="product-upsell-div desk checkout">
                            <div class="upsell_box-header-bar">
                                <div class="text-block-1180">Boost Energy + Eliminate Nausea </div>
                            </div>
                            <div class="item-text-div checkout">
                                <div class="item-details-div upsell bundle">
                                    <div class="upsell-img-div bundle"><img src="@/assets/images/NS_Bundle_B12Zofram.png" loading="lazy" sizes="(max-width: 479px) 100vw, 223.1953125px" srcset="@/assets/images/NS_Bundle_B12Zofram-p-500.png 500w, @/assets/images/NS_Bundle_B12Zofram-p-800.png 800w, @/assets/images/NS_Bundle_B12Zofram.png 1080w" alt="" class="bundle-img"></div>
                                    <div class="upsell_boxinfo upsell bundle">
                                        <div class="upsellboxtop_div bundle">
                                            <div class="mobile_img_div bundle"><img src="@/assets/images/NS_Bundle_B12Zofram.png" loading="lazy" sizes="(max-width: 479px) 54vw, 100vw" srcset="@/assets/images/NS_Bundle_B12Zofram-p-500.png 500w, @/assets/images/NS_Bundle_B12Zofram-p-800.png 800w, @/assets/images/NS_Bundle_B12Zofram.png 1080w" alt="" class="mobile-image bundle"></div>
                                            <div class="upsell_top_info_div bundle">
                                                <div class="reco-box-top upsell">
                                                    <div class="div-block-1743"><img src="@/assets/images/icon_-RX-black.svg" loading="lazy" alt="" class="image-408 upsell">
                                                        <div class="text-block-790">Prescription</div>
                                                    </div>
                                                    <div class="category-text upsell">WEIGHT LOSS</div>
                                                </div>
                                                <div class="item-name-price-div upsell bundle">
                                                    <div class="item-name-side">
                                                        <div class="productname upsell bundle">GLP Boost Bundle</div>
                                                        <div class="text-block-959">90 Day Supply of Medication</div>
                                                    </div>
                                                    <div class="price-side upsell">
                                                        <div class="old-price">
                                                            <div class="item-price-div">
                                                                <div class="dollar-sign">$</div>
                                                                <div class="price old upsell">149</div><img src="@/assets/images/discount-x-01.png" loading="lazy" width="69" sizes="(max-width: 479px) 33.9296875px, 47.8359375px" alt="" srcset="@/assets/images/discount-x-01-p-500.png 500w, @/assets/images/discount-x-01-p-800.png 800w, @/assets/images/discount-x-01-p-1080.png 1080w, @/assets/images/discount-x-01-p-1600.png 1600w, @/assets/images/discount-x-01-p-2000.png 2000w, @/assets/images/discount-x-01-p-2600.png 2600w, @/assets/images/discount-x-01-p-3200.png 3200w, @/assets/images/discount-x-01.png 3912w" class="image-450">
                                                            </div>
                                                        </div>
                                                        <div class="discount-price">
                                                            <div class="item-price-div">
                                                                <div class="dollar-sign">$</div>
                                                                <div class="price upsell">27.97</div>
                                                            </div>
                                                            <div class="text-block-962"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="upsell_boxbullets_div bundle">
                                            <div class="bullets-header-text">8mg Zofran (30 Pills) + B12 Compound</div>
                                            <div class="list-headers-div">
                                                <div class="list-header-box">
                                                    <div class="list-header bundle">Injectable B12</div>
                                                </div>
                                                <div class="list-header-box">
                                                    <div class="list-header bundle">8mg Zofran Generic</div>
                                                </div>
                                            </div>
                                            <div class="list-flex-div bundle">
                                                <ul role="list" class="list-10">
                                                    <li>
                                                        <div class="checkout_upsellbullet_text bundle">Boost daily energy </div>
                                                    </li>
                                                    <li>
                                                        <div class="checkout_upsellbullet_text bundle">Improve cognitive function</div>
                                                    </li>
                                                </ul>
                                                <ul role="list" class="list-10">
                                                    <li>
                                                        <div class="checkout_upsellbullet_text bundle">Instant Nausea Relief</div>
                                                    </li>
                                                    <li>
                                                        <div class="checkout_upsellbullet_text bundle">Eliminate top side effects</div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="popup-buttons-div upsell">
                                    <a href="#" @click.prevent="setMedSelected('Bundle')" class="upsell_boxbutton w-button">CLICK TO ADD TO ORDER</a>
                                </div>
                            </div>
                        </div>
                        <p class="paragraph-154"><strong class="fart">Or buy individually:</strong></p>
                        <div class="product-upsell-div desk checkout no-header">
                            <div class="item-text-div checkout">
                                <div class="item-details-div upsell">
                                    <div class="upsell-img-div"><img src="@/assets/images/B12-Vial.png" loading="lazy" width="178" sizes="(max-width: 479px) 100vw, 133.9140625px" alt="" srcset="@/assets/images/B12-Vial-p-500.png 500w, @/assets/images/B12-Vial-p-800.png 800w, @/assets/images/B12-Vial.png 1080w"></div>
                                    <div class="upsell_boxinfo upsell">
                                        <div class="upsellboxtop_div">
                                            <div class="mobile_img_div"><img src="@/assets/images/NS_B12Vial.png" loading="lazy" sizes="(max-width: 479px) 8vw, 100vw" srcset="@/assets/images/NS_B12Vial-p-500.png 500w, @/assets/images/NS_B12Vial.png 554w" alt="" class="mobile-image b12"></div>
                                            <div class="upsell_top_info_div">
                                                <div class="reco-box-top upsell">
                                                    <div class="div-block-1743"><img src="@/assets/images/icon_-RX-black.svg" loading="lazy" alt="" class="image-408 upsell">
                                                        <div class="text-block-790">Prescription</div>
                                                    </div>
                                                    <div class="category-text upsell">WEIGHT LOSS</div>
                                                </div>
                                                <div class="item-name-price-div upsell">
                                                    <div class="item-name-side">
                                                        <div class="productname upsell">GLP Energy</div>
                                                        <div class="text-block-959">90 Day Supply of B12 Injections</div>
                                                    </div>
                                                    <div class="price-side">
                                                        <div class="old-price">
                                                            <div class="item-price-div">
                                                                <div class="dollar-sign">$</div>
                                                                <div class="price old upsell">74</div><img src="@/assets/images/discount-x-01.png" loading="lazy" width="122" sizes="(max-width: 479px) 24.4765625px, 34.484375px" alt="" srcset="@/assets/images/discount-x-01-p-500.png 500w, @/assets/images/discount-x-01-p-800.png 800w, @/assets/images/discount-x-01-p-1080.png 1080w, @/assets/images/discount-x-01-p-1600.png 1600w, @/assets/images/discount-x-01-p-2000.png 2000w, @/assets/images/discount-x-01-p-2600.png 2600w, @/assets/images/discount-x-01-p-3200.png 3200w, @/assets/images/discount-x-01.png 3912w" class="image-450">
                                                            </div>
                                                        </div>
                                                        <div class="discount-price">
                                                            <div class="item-price-div">
                                                                <div class="dollar-sign">$</div>
                                                                <div class="price upsell">19.97</div>
                                                            </div>
                                                            <div class="text-block-962"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="upsell_boxbullets_div">
                                            <div class="list-flex-div">
                                                <ul role="list" class="list-10">
                                                    <li>
                                                        <div class="checkout_upsellbullet_text">Boost daily energy</div>
                                                    </li>
                                                </ul>
                                                <ul role="list" class="list-10">
                                                    <li>
                                                        <div class="checkout_upsellbullet_text">10 Times More Potent</div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <a href="#" @click.prevent="setMedSelected('B12')" class="upsell_boxbutton solo w-button">ADD TO ORDER</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="product-upsell-div desk checkout">
                            <div class="item-text-div checkout">
                                <div class="item-details-div upsell">
                                    <div class="upsell-img-div"><img src="@/assets/images/NS_Zorfran-SQ.png" loading="lazy" width="178" sizes="(max-width: 479px) 100vw, 133.9140625px" alt="" srcset="@/assets/images/NS_Zorfran-SQ-p-500.png 500w, @/assets/images/NS_Zorfran-SQ-p-800.png 800w, @/assets/images/NS_Zorfran-SQ.png 1080w"></div>
                                    <div class="upsell_boxinfo upsell">
                                        <div class="upsellboxtop_div">
                                            <div class="mobile_img_div"><img src="@/assets/images/Zofran_NS.png" loading="lazy" sizes="(max-width: 479px) 8vw, 100vw" srcset="@/assets/images/Zofran_NS-p-500.png 500w, @/assets/images/Zofran_NS.png 600w" alt="" class="mobile-image zofram"></div>
                                            <div class="upsell_top_info_div">
                                                <div class="reco-box-top upsell">
                                                    <div class="div-block-1743"><img src="@/assets/images/icon_-RX-black.svg" loading="lazy" alt="" class="image-408 upsell">
                                                        <div class="text-block-790">Prescription</div>
                                                    </div>
                                                    <div class="category-text upsell">WEIGHT LOSS</div>
                                                </div>
                                                <div class="item-name-price-div upsell">
                                                    <div class="item-name-side">
                                                        <div class="productname upsell">GLP Anti-Nausea</div>
                                                        <div class="text-block-959">90 Day Supply. 30 8mg Pills</div>
                                                    </div>
                                                    <div class="price-side">
                                                        <div class="old-price">
                                                            <div class="item-price-div">
                                                                <div class="dollar-sign">$</div>
                                                                <div class="price old upsell">74</div><img src="@/assets/images/discount-x-01.png" loading="lazy" width="122" sizes="(max-width: 479px) 24.4765625px, 34.484375px" alt="" srcset="@/assets/images/discount-x-01-p-500.png 500w, @/assets/images/discount-x-01-p-800.png 800w, @/assets/images/discount-x-01-p-1080.png 1080w, @/assets/images/discount-x-01-p-1600.png 1600w, @/assets/images/discount-x-01-p-2000.png 2000w, @/assets/images/discount-x-01-p-2600.png 2600w, @/assets/images/discount-x-01-p-3200.png 3200w, @/assets/images/discount-x-01.png 3912w" class="image-450">
                                                            </div>
                                                        </div>
                                                        <div class="discount-price">
                                                            <div class="item-price-div">
                                                                <div class="dollar-sign">$</div>
                                                                <div class="price upsell">19.97</div>
                                                            </div>
                                                            <div class="text-block-962"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="upsell_boxbullets_div">
                                            <div class="list-flex-div">
                                                <ul role="list" class="list-10">
                                                    <li>
                                                        <div class="checkout_upsellbullet_text">Instant Nausea Relief</div>
                                                    </li>
                                                </ul>
                                                <ul role="list" class="list-10">
                                                    <li>
                                                        <div class="checkout_upsellbullet_text">Works in Minutes</div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <a href="#" @click.prevent="setMedSelected('Nausea')" class="upsell_boxbutton solo w-button">ADD TO ORDER</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="upsell-button-div">
                            <a href="#" @click.prevent="moveToNext()" class="button-113 w-button"><strong>&quot;I&#x27;m Not Interested in Eliminating My Side Effects&quot;</strong> <span class="text-span-254">-&gt;</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    <!-- step 2 of the page -->
    <section class="checkout-section" v-if="active_el==2">
    <div class="checkoutb_wrap">
      <div class="checkoutb_div">
        <div class="ty_maindiv">
            <div class="text-block-1141" style="font-size: 32px;">Thank you for Signing up!</div>
          <div class="text-block-1141">You made the right choice {{user.first_name}}!</div>
          <div class="text-block-1142">Your Current Medical Weight Loss Regimen:</div>
          <div class="productbar_div">
            <div class="barflex">
              <div class="barimg_div"><img src="@/assets/images/NS_SemaglutideColorVialSQ.png" loading="lazy" sizes="(max-width: 479px) 18vw, 115.59375px" srcset="@/assets/images/NS_SemaglutideColorVialSQ-p-500.png 500w, @/assets/images/NS_SemaglutideColorVialSQ-p-800.png 800w, @/assets/images/NS_SemaglutideColorVialSQ.png 1080w" alt=""></div>
              <div class="barinfo_div">
                <div class="bar-header">
                  <div class="bar-header-text">{{getProductName}}</div>
                  <div class="text-block-1144">weekly injection</div>
                </div>
                <div class="bar-subheader-text">All Dosage Levels...same price!</div>
                <div class="bar-body-text">Remove food noise, eat less and drop weight fast with a once weekly mini-injection</div>
              </div>
              <div class="barprice_div">
                <img src="@/assets/images/icon_Check-green.svg" loading="lazy" alt="" class="selected-plan-img">
                <div class="text-block-1149">Plan Selected</div>
              </div>
            </div>
          </div>
          <div class="productbar_div" v-if="selectedOption==='Bundle'">
            <div class="barflex">
              <div class="barimg_div"><img src="@/assets/images/NS_Bundle_B12Zofram.png" loading="lazy" sizes="(max-width: 479px) 18vw, 115.59375px" srcset="@/assets/images/NS_Bundle_B12Zofram-p-500.png 500w, @/assets/images/NS_Bundle_B12Zofram-p-800.png 800w, @/assets/images/NS_Bundle_B12Zofram.png 1080w" alt=""></div>
              <div class="barinfo_div">
                <div class="bar-header">
                  <div class="bar-header-text">GLP Boost Bundle </div>
                </div>
                <div class="bar-subheader-text">GLP Anti-Nausea + Energy Prescriptions<br></div>
                <ul role="list" class="list-8">
                  <li class="list-item-7"><span class="text-span-251">Anti-Nausea</span> 8mg Generic Zofran® (ondansetron) to eliminate nausea.</li>
                  <li class="list-item-8"><span class="text-span-251">More Energy:</span> Once Weekly B12 Injections to reduce GLP fatigue and boost metabolism.</li>
                </ul>
              </div>
              <div class="barprice_div">
                <div class="div-block-1951">
                  <div class="text-block-1147">$</div>
                  <div class="text-block-1148">24</div>
                  <div class="text-block-1146">97</div>
                </div>
                <div class="text-block-1149">Monthly</div>
              </div>
            </div><img src="@/assets/images/icon_Check-green.svg" loading="lazy" alt="" class="image-509">
          </div>
          <div class="productbar_div" v-if="selectedOption==='B12'">
            <div class="barflex">
              <div class="barimg_div"><img src="@/assets/images/B12-Vial.png" loading="lazy" sizes="(max-width: 479px) 18vw, 115.59375px" srcset="@/assets/images/B12-Vial-p-500.png 500w, @/assets/images/B12-Vial-p-800.png 800w, @/assets/images/B12-Vial.png 1080w" alt=""></div>
              <div class="barinfo_div">
                <div class="bar-header">
                  <div class="bar-header-text">GLP Energy </div>
                  <div class="text-block-1144">weekly injection</div>
                </div>
                <div class="bar-subheader-text">B12 Injections</div>
                <div class="bar-body-text">Conquer the day with the energy to fight fatigue, boost metabolism, and sharpen focus.</div>
              </div>
              <div class="barprice_div">
                <div class="div-block-1951">
                  <div class="text-block-1147">$</div>
                  <div class="text-block-1148">19</div>
                  <div class="text-block-1146">97</div>
                </div>
                <div class="text-block-1149"></div>
              </div>
            </div><img src="@/assets/images/icon_Check-green.svg" loading="lazy" alt="" class="image-509">
          </div>

          <div class="productbar_div gift" v-if="selectedOption==='Nausea'">
          <div class="barflex">
            <div class="barimg_div"><img src="@/assets/images/NS_Zorfran-SQ.png" loading="lazy" sizes="(max-width: 479px) 18vw, 114.796875px" srcset="@/assets/images/NS_Zorfran-SQ-p-500.png 500w, @/assets/images/NS_Zorfran-SQ-p-800.png 800w, @/assets/images/NS_Zorfran-SQ.png 1080w" alt=""></div>
            <div class="barinfo_div gift">
              <div class="bar-header gift">
                <div class="bar-header-text">GLP Anti-Nausea</div>
                <div class="text-block-1144"><strong>30</strong> Pills</div>
              </div>
              <div class="bar-subheader-text">8mg Generic Zofran® (ondansetron)</div>
              <div class="bar-body-text">Eliminate nausea, the most common GLP side effect in one easy to take melt-away tablet.</div>
            </div>
            <div class="barprice_div">
                <div class="div-block-1951">
                  <div class="text-block-1147">$</div>
                  <div class="text-block-1148">19</div>
                  <div class="text-block-1146">97</div>
                </div>
                <div class="text-block-1149"></div>
              </div>
          </div><img src="@/assets/images/icon_Check-green.svg" loading="lazy" alt="" class="image-509">
        </div>

          <div class="ty_no-div" v-if="selectedOption!=='Bundle'">
            <div class="text-block-1150"><span class="text-span-245">We noticed you decided to pass on {{ getDrugName }}, </span>but we understand how vital it can be in helping you manage side effects that might stand in the way of completing our program and reaching your weight loss goals.</div>
          </div>
        </div>
        <div class="ty_gift_div" v-if="selectedOption!=='Bundle'">
          <div class="text-block-1150"><span class="text-span-245 under">As a thank-you for being a valued new customer, </span>we&#x27;re including it complimentary with your order. It&#x27;s our way of supporting you on this journey and ensuring you have everything you need to succeed.</div>
        </div>
        <div class="productbar_div gift" v-if="selectedOption==='B12'">
          <div class="barflex">
            <div class="barimg_div"><img src="@/assets/images/NS_Zorfran-SQ.png" loading="lazy" sizes="(max-width: 479px) 18vw, 114.796875px" srcset="@/assets/images/NS_Zorfran-SQ-p-500.png 500w, @/assets/images/NS_Zorfran-SQ-p-800.png 800w, @/assets/images/NS_Zorfran-SQ.png 1080w" alt=""></div>
            <div class="barinfo_div gift">
              <div class="bar-header gift">
                <div class="bar-header-text">GLP Anti-Nausea</div>
                <div class="text-block-1144"><strong>30</strong> Pills</div>
              </div>
              <div class="bar-subheader-text">8mg Generic Zofran® (ondansetron)</div>
              <div class="bar-body-text">Eliminate nausea, the most common GLP side effect in one easy to take melt-away tablet.</div>
            </div>
            <div class="barprice_div">
              <div class="div-block-1951">
                <div class="text-block-1148"><span class="text-span-246">FREE</span></div>
              </div>
            </div>
          </div><img src="@/assets/images/icon_Check-green.svg" loading="lazy" alt="" class="image-509">
        </div>
        <div class="productbar_div gift" v-else-if="selectedOption==='Nausea'">
          <div class="barflex">
            <div class="barimg_div"><img src="@/assets/images/NS_Zorfran-SQ.png" loading="lazy" sizes="(max-width: 479px) 18vw, 114.796875px" srcset="@/assets/images/NS_Zorfran-SQ-p-500.png 500w, @/assets/images/NS_Zorfran-SQ-p-800.png 800w, @/assets/images/NS_Zorfran-SQ.png 1080w" alt=""></div>
            <div class="barinfo_div gift">
              <div class="bar-header gift">
                <div class="bar-header-text">GLP Energy</div>
                <div class="text-block-1144">weekly injection</div>
              </div>
              <div class="bar-subheader-text">B12 Injections</div>
              <div class="bar-body-text">Conquer the day with the energy to fight fatigue, boost metabolism, and sharpen focus.</div>
            </div>
            <div class="barprice_div">
              <div class="div-block-1951">
                <div class="text-block-1148"><span class="text-span-246">FREE</span></div>
              </div>
            </div>
          </div><img src="@/assets/images/icon_Check-green.svg" loading="lazy" alt="" class="image-509">
        </div>
        <div class="productbar_div" v-if="selectedOption===''">
            <div class="barflex">
              <div class="barimg_div"><img src="@/assets/images/NS_Bundle_B12Zofram.png" loading="lazy" sizes="(max-width: 479px) 18vw, 115.59375px" srcset="@/assets/images/NS_Bundle_B12Zofram-p-500.png 500w, @/assets/images/NS_Bundle_B12Zofram-p-800.png 800w, @/assets/images/NS_Bundle_B12Zofram.png 1080w" alt=""></div>
              <div class="barinfo_div">
                <div class="bar-header">
                  <div class="bar-header-text">GLP Boost Bundle </div>
                </div>
                <div class="bar-subheader-text">GLP Anti-Nausea + Energy Prescriptions<br></div>
                <ul role="list" class="list-8">
                  <li class="list-item-7"><span class="text-span-251">Anti-Nausea</span> 8mg Generic Zofran® (ondansetron) to eliminate nausea.</li>
                  <li class="list-item-8"><span class="text-span-251">More Energy:</span> Once Weekly B12 Injections to reduce GLP&nbsp;fatigue and boost metabolism.</li>
                </ul>
              </div>
              <div class="barprice_div">
              <div class="div-block-1951">
                <div class="text-block-1148"><span class="text-span-246">FREE</span></div>
              </div>
                </div>
            </div><img src="images/icon_Check-green.svg" loading="lazy" alt="" class="image-509">
          </div>
        <div class="ty_buttondiv">
          <a href="#" @click="addBundleAndMove()" class="button-109 w-button">Next Step <span class="text-span-247">-&gt;</span></a>
        </div>
      </div>
    </div>
  </section>
  <section class="checkout-section" v-if="active_el==3">
    <div class="checkoutb_wrap">
      <div class="checkoutb_div">
        <div class="almostdone-div">
          <div class="text-block-1151">Almost Done {{user.first_name}}!</div>
          <div class="text-block-1152">Our 100% digital process will ensure you can start your medical weightloss journey and start in as little as 2 Days.</div>
          <div class="timeline-div">
            <div class="timeline_line"></div>
            <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
              <div>
                <div class="text-block-1153"><strong>5-10 minutes</strong></div>
                <div class="text-block-1154">Complete Medical Questionnaire</div>
                <div class="text-block-1155">Fill out a short online form to submit to the doctor.</div>
              </div>
            </div>
            <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
              <div>
                <div class="text-block-1153"><strong>24 Hours or Less</strong></div>
                <div class="text-block-1154">Doctor Review &amp; Prescription</div>
                <div class="text-block-1155">Most patients do not require a video doctor visit. If approved you will receive an instant notification.</div>
              </div>
            </div>
            <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
              <div>
                <div class="text-block-1153"><strong>Same Day Processing</strong></div>
                <div class="text-block-1154">Our Pharmacy Processes Your Order</div>
                <div class="text-block-1155">Our US Based, FDA Approved Pharmacies process your order same day if before 3 (Mon-Thursday)</div>
              </div>
            </div>
            <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
              <div>
                <div class="text-block-1153"><strong>48 Hours or Less</strong></div>
                <div class="text-block-1154">FREE 2 Day Express Shipping</div>
                <div class="text-block-1155">You can track the packages and get updates directly in our portal.</div>
              </div>
            </div>
          </div>
          <div class="almost_bottomflex_div">
            <div><img src="@/assets/images/stepsimage_teledoc_nS.png" loading="lazy" sizes="(max-width: 479px) 17vw, 74.5625px" srcset="@/assets/images/stepsimage_teledoc_nS-p-500.png 500w, @/assets/images/stepsimage_teledoc_nS.png 641w" alt="" class="image-511"></div>
            <p class="paragraph-153">During this time you can access our Medical Weight Loss Biohacking Guide to help you prepare prior to receiving medication.</p>
          </div>
          <div class="almost-button-div">
            <a href="#" class="button-109 w-button" @click="pushToMedForm()">Complete Medical Form <span class="text-span-247">-&gt;</span></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>
<script>

import { mapGetters } from 'vuex';
export default {
    name: 'paymentThanks',
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            active_el: 1,
            selectedOption:'',
        }
    },
    computed:{
        ...mapGetters(['getRemainingPrescriptions','user']),
        remainingPrescriptions() {
            return this.getRemainingPrescriptions;
        },
        getDrugName(){
            return this.selectedOption === '' ? 'GLP Anti-Nausea and GLP Energy' : this.selectedOption === 'B12' ? 'GLP Anti-Nausea' : 'GLP Energy'
        },
        getProductName(){
            return JSON.parse(localStorage.getItem("planName"))
        }
    },
    methods:{
        setMedSelected(value){
            this.selectedOption = value;
            this.moveToNext();
        },
        moveToNext(){
            this.active_el=2;
        },
        async addBundleAndMove(){
            if(this.selectedOption!=''){
                await this.$axios.post(`${this.baseUrl}/api/bundle-selected`, {
                    selectedMed: this.selectedOption
                });
                
            }
            this.active_el=3;
        },
        pushToMedForm(){
            try{

             let order = this.remainingPrescriptions[0];
             console.log(order);
                this.$router.push({
                    name: 'FormLoader',
                    params: {
                        id: order.orderId
                    }
                });
            }catch(error){
                alert("No pending order found.")
            }
        }
    },
    mounted(){
        console.log(this.remainingPrescriptions)
    }
}
</script>
<style scoped>
.selected-plan-img{
    width: 45px;
}
</style>